import { ArticleDisplay, ArticleDesign, ArticleSpecial, ArticlePillar, } from '@guardian/libs';
import { neutral, text, specialReport, opinion, news, sport, brandAltBackground, border, brand, brandAlt, lifestyle, culture, labs, } from '@guardian/source-foundations';
// Here is the one place where we use `pillarPalette`
import { pillarPalette_DO_NOT_USE as pillarPalette } from '../../lib/pillars';
const WHITE = neutral[100];
const BLACK = neutral[7];
const blogsGrayBackgroundPalette = (format) => {
    switch (format.theme) {
        case ArticlePillar.News:
            return pillarPalette[format.theme].main;
        default:
            return pillarPalette[format.theme].dark;
    }
};
const textHeadline = (format) => {
    switch (format.display) {
        case ArticleDisplay.Immersive:
            if (format.theme === ArticleSpecial.SpecialReport)
                return WHITE;
            switch (format.design) {
                case ArticleDesign.PrintShop:
                    return BLACK;
                default:
                    return WHITE;
            }
        case ArticleDisplay.Showcase:
        case ArticleDisplay.NumberedList:
        case ArticleDisplay.Standard: {
            if (format.theme === ArticleSpecial.SpecialReport &&
                format.design !== ArticleDesign.Interview)
                return specialReport[100];
            switch (format.design) {
                case ArticleDesign.Review:
                case ArticleDesign.Recipe:
                case ArticleDesign.Feature:
                    return pillarPalette[format.theme].dark;
                case ArticleDesign.Interview:
                case ArticleDesign.LiveBlog:
                    return WHITE;
                default:
                    return BLACK;
            }
        }
        default:
            return BLACK;
    }
};
const textSeriesTitle = (format) => {
    if (format.theme === ArticleSpecial.Labs)
        return BLACK;
    if (format.theme === ArticleSpecial.SpecialReport)
        return specialReport[300];
    switch (format.display) {
        case ArticleDisplay.Immersive:
            return WHITE;
        case ArticleDisplay.Showcase:
        case ArticleDisplay.NumberedList:
        case ArticleDisplay.Standard:
            switch (format.design) {
                case ArticleDesign.LiveBlog:
                    switch (format.theme) {
                        case ArticlePillar.News:
                            return news[600];
                        case ArticlePillar.Sport:
                        case ArticlePillar.Lifestyle:
                        case ArticlePillar.Culture:
                        case ArticlePillar.Opinion:
                        default:
                            return WHITE;
                    }
                case ArticleDesign.DeadBlog:
                    return blogsGrayBackgroundPalette(format);
                case ArticleDesign.MatchReport:
                    return BLACK;
                default:
                    return pillarPalette[format.theme].main;
            }
        default:
            return BLACK;
    }
};
const textSectionTitle = textSeriesTitle;
const textByline = (format) => {
    if (format.design === ArticleDesign.LiveBlog ||
        format.design === ArticleDesign.DeadBlog)
        return blogsGrayBackgroundPalette(format);
    if (format.theme === ArticleSpecial.Labs)
        return BLACK;
    if (format.theme === ArticleSpecial.SpecialReport)
        return specialReport[300];
    switch (format.display) {
        case ArticleDisplay.Immersive:
            return WHITE;
        case ArticleDisplay.Showcase:
        case ArticleDisplay.NumberedList:
        case ArticleDisplay.Standard:
            switch (format.design) {
                case ArticleDesign.Interview:
                    return BLACK;
                default:
                    return pillarPalette[format.theme].main;
            }
        default:
            return pillarPalette[format.theme].main;
    }
};
const textHeadlineByline = (format) => {
    if (format.theme === ArticleSpecial.SpecialReport)
        return specialReport[300];
    if (format.theme === ArticleSpecial.Labs)
        return BLACK;
    return pillarPalette[format.theme].main;
};
const textStandfirst = (format) => {
    if (format.design === ArticleDesign.LiveBlog)
        return WHITE;
    return BLACK;
};
const textTwitterHandle = (format) => {
    if (format.theme === ArticleSpecial.Labs)
        return BLACK;
    if (format.theme === ArticleSpecial.SpecialReport)
        return specialReport[300];
    return text.supporting;
};
const textCaption = (format) => {
    if (format.theme === ArticleSpecial.SpecialReport)
        return specialReport[100];
    if (format.theme === ArticleSpecial.Labs)
        return neutral[20];
    switch (format.design) {
        case ArticleDesign.PhotoEssay:
            return pillarPalette[format.theme].dark;
        default:
            return text.supporting;
    }
};
const textCaptionLink = (format) => {
    if (format.theme === ArticleSpecial.SpecialReport)
        return specialReport[300];
    return pillarPalette[format.theme].main;
};
const textSubMeta = (format) => {
    if (format.theme === ArticleSpecial.Labs)
        return BLACK;
    if (format.theme === ArticleSpecial.SpecialReport)
        return specialReport[100];
    if (format.design === ArticleDesign.DeadBlog)
        return blogsGrayBackgroundPalette(format);
    return pillarPalette[format.theme].main;
};
const textSubMetaLabel = (format) => {
    if (format.theme === ArticleSpecial.Labs)
        return BLACK;
    if (format.theme === ArticleSpecial.SpecialReport)
        return specialReport[300];
    return text.supporting;
};
const textSubMetaLink = (format) => {
    if (format.theme === ArticleSpecial.Labs)
        return BLACK;
    if (format.theme === ArticleSpecial.SpecialReport)
        return specialReport[300];
    return text.supporting;
};
const textSyndicationButton = (format) => {
    if (format.theme === ArticleSpecial.Labs)
        return BLACK;
    if (format.theme === ArticleSpecial.SpecialReport)
        return specialReport[100];
    return text.supporting;
};
const textArticleLink = (format) => {
    if (format.design === ArticleDesign.DeadBlog) {
        switch (format.theme) {
            case ArticlePillar.News:
                return news[400];
            case ArticlePillar.Culture:
                return culture[350];
            case ArticlePillar.Lifestyle:
                return lifestyle[400];
            case ArticlePillar.Sport:
                return sport[400];
            case ArticlePillar.Opinion:
                return opinion[300];
            case ArticleSpecial.Labs:
                return BLACK;
            case ArticleSpecial.SpecialReport:
                return specialReport[400];
        }
    }
    if (format.theme === ArticleSpecial.Labs)
        return BLACK;
    if (format.theme === ArticleSpecial.SpecialReport)
        return specialReport[400];
    switch (format.theme) {
        case ArticlePillar.Opinion:
        case ArticlePillar.Culture:
            return pillarPalette[format.theme].dark;
        default:
            return pillarPalette[format.theme].main;
    }
};
const textDisclaimerLink = (format) => pillarPalette[format.theme].dark;
const textWitnessIcon = (format) => pillarPalette[format.theme].main;
const textWitnessTitle = (format) => pillarPalette[format.theme].main;
const textWitnessAuthor = (format) => pillarPalette[format.theme].main;
const textPullQuote = (format) => {
    return pillarPalette[format.theme].dark;
};
const textStandfirstLink = (format) => {
    if (format.design === ArticleDesign.LiveBlog)
        return WHITE;
    if (format.design === ArticleDesign.DeadBlog) {
        switch (format.theme) {
            case ArticlePillar.Opinion:
                return opinion[200];
            case ArticlePillar.News:
                return news[400];
            default:
                return pillarPalette[format.theme].dark;
        }
    }
    if (format.theme === ArticleSpecial.SpecialReport)
        return specialReport[400];
    switch (format.theme) {
        case ArticlePillar.Opinion:
        case ArticlePillar.Culture:
            return pillarPalette[format.theme].dark;
        default:
            return pillarPalette[format.theme].main;
    }
};
const textBranding = (format) => {
    if (format.theme === ArticleSpecial.Labs)
        return BLACK;
    return pillarPalette[format.theme].main;
};
const textArticleLinkHover = (format) => {
    if (format.design === ArticleDesign.DeadBlog) {
        switch (format.theme) {
            case ArticlePillar.News:
                return news[400];
            case ArticlePillar.Culture:
                return culture[350];
            case ArticlePillar.Lifestyle:
                return lifestyle[400];
            case ArticlePillar.Sport:
                return sport[400];
            case ArticlePillar.Opinion:
                return opinion[300];
            case ArticleSpecial.Labs:
                return BLACK;
            case ArticleSpecial.SpecialReport:
                return specialReport[100];
        }
    }
    if (format.theme === ArticleSpecial.Labs)
        return BLACK;
    if (format.theme === ArticleSpecial.SpecialReport)
        return specialReport[100];
    switch (format.theme) {
        case ArticlePillar.Opinion:
        case ArticlePillar.Culture:
            return pillarPalette[format.theme].dark;
        default:
            return pillarPalette[format.theme].main;
    }
};
const textCardHeadline = (format) => {
    if (format.theme === ArticleSpecial.SpecialReport)
        return WHITE;
    if (format.display === ArticleDisplay.Immersive)
        return BLACK;
    switch (format.design) {
        case ArticleDesign.Feature:
        case ArticleDesign.Interview:
            return pillarPalette[format.theme].dark;
        case ArticleDesign.Media:
            return WHITE;
        case ArticleDesign.LiveBlog:
            switch (format.theme) {
                case ArticleSpecial.Labs:
                    return BLACK;
                case ArticlePillar.News:
                case ArticlePillar.Sport:
                case ArticlePillar.Opinion:
                case ArticlePillar.Culture:
                case ArticlePillar.Lifestyle:
                default:
                    return WHITE;
            }
        default:
            return BLACK;
    }
};
const textCardStandfirst = textCardHeadline;
/** same as textByline except for SpecialReport */
const textCardByline = (format) => {
    if (format.theme === ArticleSpecial.SpecialReport)
        return specialReport[700];
    return textByline(format);
};
const textCardKicker = (format) => {
    if (format.theme === ArticleSpecial.SpecialReport &&
        (format.design === ArticleDesign.Comment ||
            format.design === ArticleDesign.Letter))
        // TODO: Pull this in from source as opinion[550]
        // https://theguardian.design/2a1e5182b/p/492a30-light-palette
        return '#ff9941';
    if (format.theme === ArticleSpecial.SpecialReport)
        return brandAlt[400];
    switch (format.design) {
        case ArticleDesign.LiveBlog:
            switch (format.theme) {
                case ArticlePillar.News:
                    return news[600];
                case ArticlePillar.Sport:
                    return sport[600];
                case ArticlePillar.Opinion:
                    return WHITE;
                case ArticlePillar.Culture:
                    return culture[600];
                case ArticlePillar.Lifestyle:
                    return lifestyle[500];
                case ArticleSpecial.Labs:
                default:
                    return BLACK;
            }
        case ArticleDesign.Media:
            switch (format.theme) {
                case ArticlePillar.News:
                    return news[600];
                case ArticlePillar.Sport:
                    return sport[600];
                case ArticlePillar.Opinion:
                    // TODO: Pull this in from source as opinion[550]
                    // https://theguardian.design/2a1e5182b/p/492a30-light-palette
                    return '#ff9941';
                case ArticlePillar.Lifestyle:
                case ArticlePillar.Culture:
                default:
                    return pillarPalette[format.theme][500];
            }
        default:
            return pillarPalette[format.theme].main;
    }
};
const textCardFooter = (format) => {
    switch (format.design) {
        case ArticleDesign.Comment:
        case ArticleDesign.Letter:
            switch (format.theme) {
                case ArticleSpecial.SpecialReport:
                    // TODO: Pull this in from souce once we see it here:
                    // https://theguardian.design/2a1e5182b/p/492a30-light-palette
                    return '#ff9941';
                default:
                    return neutral[60];
            }
        case ArticleDesign.LiveBlog:
            switch (format.theme) {
                case ArticlePillar.News:
                    return news[600];
                case ArticlePillar.Sport:
                    return sport[600];
                case ArticlePillar.Opinion:
                    return WHITE;
                case ArticlePillar.Culture:
                    return culture[600];
                case ArticlePillar.Lifestyle:
                    return lifestyle[500];
                case ArticleSpecial.SpecialReport:
                    return brandAlt[400];
                case ArticleSpecial.Labs:
                default:
                    return BLACK;
            }
        case ArticleDesign.Media:
            switch (format.theme) {
                case ArticleSpecial.SpecialReport:
                    return brandAlt[400];
                case ArticlePillar.News:
                    return news[600];
                case ArticlePillar.Sport:
                    return sport[600];
                case ArticlePillar.Opinion:
                    // TODO: Pull this in from source as opinion[550]
                    // https://theguardian.design/2a1e5182b/p/492a30-light-palette
                    return '#ff9941';
                case ArticlePillar.Lifestyle:
                case ArticlePillar.Culture:
                default:
                    return pillarPalette[format.theme][500];
            }
        default:
            switch (format.theme) {
                case ArticleSpecial.SpecialReport:
                    return brandAltBackground.primary;
                default:
                    return neutral[60];
            }
    }
};
const textLinkKicker = (format) => {
    return pillarPalette[format.theme].main;
};
const backgroundArticle = (format) => {
    if (format.design === ArticleDesign.LiveBlog ||
        format.design === ArticleDesign.DeadBlog)
        return neutral[97];
    // Order matters. We want comment special report pieces to have the opinion background
    if (format.design === ArticleDesign.Letter)
        return opinion[800];
    if (format.design === ArticleDesign.Comment)
        return opinion[800];
    if (format.design === ArticleDesign.Editorial)
        return opinion[800];
    if (format.theme === ArticleSpecial.SpecialReport)
        return specialReport[800]; // Note, check theme rather than design here
    if (format.theme === ArticleSpecial.Labs &&
        format.display !== ArticleDisplay.Immersive)
        return neutral[97];
    return 'transparent';
};
const backgroundSeriesTitle = (format) => {
    if (format.theme === ArticleSpecial.SpecialReport)
        return brandAltBackground.primary;
    switch (format.display) {
        case ArticleDisplay.Immersive:
            return pillarPalette[format.theme].main;
        case ArticleDisplay.Showcase:
        case ArticleDisplay.NumberedList:
        case ArticleDisplay.Standard:
        default:
            return 'transparent';
    }
};
const backgroundSectionTitle = (format) => {
    switch (format.display) {
        case ArticleDisplay.Immersive:
            return pillarPalette[format.theme].main;
        case ArticleDisplay.Showcase:
        case ArticleDisplay.NumberedList:
        case ArticleDisplay.Standard:
        default:
            return 'transparent';
    }
};
const backgroundAvatar = (format) => {
    switch (format.theme) {
        case ArticleSpecial.SpecialReport:
            return specialReport[800];
        case ArticlePillar.Opinion:
            return pillarPalette[ArticlePillar.Opinion].main;
        default:
            return pillarPalette[format.theme].bright;
    }
};
const backgroundCard = (format) => {
    if (format.theme === ArticleSpecial.SpecialReport)
        return specialReport[300];
    switch (format.design) {
        case ArticleDesign.Editorial:
        case ArticleDesign.Letter:
        case ArticleDesign.Comment:
            return opinion[800];
        case ArticleDesign.Media:
            return neutral[20];
        case ArticleDesign.LiveBlog:
            switch (format.theme) {
                case ArticleSpecial.Labs:
                    return labs[400];
                case ArticlePillar.News:
                case ArticlePillar.Sport:
                case ArticlePillar.Opinion:
                case ArticlePillar.Lifestyle:
                case ArticlePillar.Culture:
                default:
                    return pillarPalette[format.theme][300];
            }
        default:
            return neutral[97];
    }
};
const backgroundHeadline = (format) => {
    switch (format.display) {
        case ArticleDisplay.Immersive:
            if (format.theme === ArticleSpecial.SpecialReport)
                return specialReport[300];
            return BLACK;
        case ArticleDisplay.Showcase:
        case ArticleDisplay.NumberedList:
        case ArticleDisplay.Standard:
            if (format.design === ArticleDesign.Interview)
                return BLACK;
            return 'transparent';
        default:
            return 'transparent';
    }
};
const backgroundHeadlineByline = (format) => {
    if (format.theme === ArticleSpecial.SpecialReport)
        return brandAltBackground.primary;
    return 'transparent';
};
const backgroundBullet = (format) => {
    if (format.theme === ArticleSpecial.Labs)
        return BLACK;
    if (format.theme === ArticleSpecial.SpecialReport)
        return specialReport[300];
    return pillarPalette[format.theme].main;
};
const backgroundBulletStandfirst = (format) => {
    switch (format.design) {
        case ArticleDesign.DeadBlog:
            return neutral[60];
        default:
            return neutral[86]; // default previously defined in Standfirst.tsx
    }
};
const backgroundHeader = (format) => {
    switch (format.design) {
        case ArticleDesign.LiveBlog:
            return pillarPalette[format.theme][400];
        default:
            return backgroundArticle(format);
    }
};
const backgroundStandfirst = (format) => {
    switch (format.design) {
        case ArticleDesign.LiveBlog:
            return pillarPalette[format.theme][300];
        case ArticleDesign.DeadBlog:
            return neutral[93];
        default:
            return backgroundArticle(format);
    }
};
const backgroundImageTitle = (format) => {
    return pillarPalette[format.theme].main;
};
const backgroundSpeechBubble = (format) => {
    return pillarPalette[format.theme].main;
};
const fillCommentCount = (format) => {
    if (format.design === ArticleDesign.LiveBlog ||
        format.design === ArticleDesign.DeadBlog)
        return neutral[46];
    if (format.theme === ArticleSpecial.Labs)
        return BLACK;
    if (format.theme === ArticleSpecial.SpecialReport)
        return specialReport[300];
    return pillarPalette[format.theme].main;
};
const fillCommentCountUntilDesktop = (format) => {
    if (format.design === ArticleDesign.LiveBlog)
        return WHITE;
    return fillCommentCount(format);
};
const fillShareIcon = (format) => {
    if (format.design === ArticleDesign.DeadBlog) {
        switch (format.theme) {
            case ArticlePillar.Culture:
                return culture[350];
            case ArticlePillar.News:
                return news[400];
            case ArticlePillar.Lifestyle:
                return lifestyle[400];
            case ArticlePillar.Sport:
                return sport[400];
            case ArticlePillar.Opinion:
                return opinion[300];
            case ArticleSpecial.Labs:
                return BLACK;
            case ArticleSpecial.SpecialReport:
                return specialReport[300];
        }
    }
    if (format.theme === ArticleSpecial.Labs)
        return BLACK;
    if (format.theme === ArticleSpecial.SpecialReport)
        return specialReport[300];
    return pillarPalette[format.theme].main;
};
const fillShareCountIcon = () => {
    return neutral[46];
};
const fillShareCountIconUntilDesktop = (format) => {
    if (format.design === ArticleDesign.LiveBlog)
        return WHITE;
    return fillShareCountIcon();
};
const fillShareIconGrayBackground = (format) => {
    switch (format.design) {
        case ArticleDesign.LiveBlog:
        case ArticleDesign.DeadBlog:
            return blogsGrayBackgroundPalette(format);
        default:
            return pillarPalette[format.theme].dark;
    }
};
const fillCaptionCamera = (format) => textCaption(format);
const fillBlockquoteIcon = (format) => pillarPalette[format.theme].main;
const fillCardIcon = (format) => {
    // Setting Card clock colour for immersive cards to all be dark grey
    if (format.display === ArticleDisplay.Immersive)
        return neutral[60];
    switch (format.design) {
        case ArticleDesign.Comment:
        case ArticleDesign.Letter:
            switch (format.theme) {
                case ArticleSpecial.SpecialReport:
                    // TODO: Pull this in from source once we see it here:
                    // https://theguardian.design/2a1e5182b/p/492a30-light-palette
                    return '#ff9941';
                default:
                    return neutral[46];
            }
            return lifestyle[500];
        case ArticleDesign.LiveBlog:
            switch (format.theme) {
                case ArticlePillar.News:
                    return news[600];
                case ArticlePillar.Sport:
                    return sport[600];
                case ArticlePillar.Opinion:
                    return WHITE;
                case ArticlePillar.Culture:
                    return culture[600];
                case ArticlePillar.Lifestyle:
                    return lifestyle[500];
                case ArticleSpecial.SpecialReport:
                    return brandAlt[400];
                case ArticleSpecial.Labs:
                default:
                    return BLACK;
            }
        case ArticleDesign.Media:
            switch (format.theme) {
                case ArticleSpecial.SpecialReport:
                    return brandAlt[400];
                case ArticlePillar.News:
                    return news[600];
                case ArticlePillar.Sport:
                    return sport[600];
                case ArticlePillar.Opinion:
                    // TODO: Pull this in from source as opinion[550]
                    // https://theguardian.design/2a1e5182b/p/492a30-light-palette
                    return '#ff9941';
                case ArticlePillar.Lifestyle:
                case ArticlePillar.Culture:
                default:
                    return pillarPalette[format.theme][500];
            }
        default:
            switch (format.theme) {
                case ArticleSpecial.SpecialReport:
                    return brandAltBackground.primary;
                default:
                    return neutral[46];
            }
    }
};
const borderSyndicationButton = (format) => {
    if (format.theme === ArticleSpecial.Labs)
        return neutral[60];
    return border.secondary;
};
const borderSubNav = (format) => {
    return pillarPalette[format.theme].main;
};
const borderLiveBlock = (format) => {
    if (format.design === ArticleDesign.DeadBlog) {
        switch (format.theme) {
            case ArticlePillar.News:
                return news[400];
            case ArticlePillar.Culture:
                return culture[350];
            case ArticlePillar.Lifestyle:
                return lifestyle[400];
            case ArticlePillar.Sport:
                return sport[400];
            case ArticlePillar.Opinion:
                return opinion[300];
            case ArticleSpecial.Labs:
                return labs[400];
            case ArticleSpecial.SpecialReport:
                return specialReport[400];
        }
    }
    return pillarPalette[format.theme].main;
};
const borderArticleLink = (format) => {
    if (format.theme === ArticleSpecial.Labs)
        return neutral[60];
    if (format.theme === ArticleSpecial.SpecialReport)
        return specialReport[400];
    return border.secondary;
};
const borderStandfirstLink = (format) => {
    if (format.design === ArticleDesign.LiveBlog)
        return WHITE;
    if (format.theme === ArticleSpecial.SpecialReport)
        return specialReport[400];
    return border.secondary;
};
const borderHeadline = (format) => {
    if (format.design === ArticleDesign.LiveBlog)
        return '#9F2423';
    if (format.design === ArticleDesign.DeadBlog)
        return '#CDCDCD';
    return border.secondary;
};
const borderStandfirst = (format) => {
    if (format.design === ArticleDesign.LiveBlog)
        return '#8C2222';
    if (format.design === ArticleDesign.DeadBlog)
        return '#BDBDBD';
    return border.secondary;
};
const matchTab = () => {
    return border.secondary;
};
const activeMatchTab = () => {
    return sport[300];
};
const backgroundMatchNav = () => {
    return '#FFE500';
};
const borderArticleLinkHover = (format) => {
    if (format.theme === ArticleSpecial.Labs)
        return BLACK;
    if (format.theme === ArticleSpecial.SpecialReport)
        return specialReport[100];
    return pillarPalette[format.theme].main;
};
const topBarCard = (format) => {
    if (format.theme === ArticleSpecial.SpecialReport)
        return brandAltBackground.primary;
    return pillarPalette[format.theme].main;
};
const hoverHeadlineByline = (format) => {
    if (format.theme === ArticleSpecial.Labs)
        return BLACK;
    return pillarPalette[format.theme].dark;
};
const textRichLink = (format) => {
    if (format) {
        switch (format.theme) {
            case ArticlePillar.News:
                return news[400];
            case ArticlePillar.Culture:
                return culture[350];
            case ArticlePillar.Lifestyle:
                return lifestyle[300];
            case ArticlePillar.Sport:
                return sport[400];
            case ArticlePillar.Opinion:
                return opinion[300];
            case ArticleSpecial.Labs:
                return BLACK;
            case ArticleSpecial.SpecialReport:
                return specialReport[400];
        }
    }
    return pillarPalette[ArticlePillar.News][400];
};
const hoverStandfirstLink = (format) => {
    if (format.design === ArticleDesign.DeadBlog)
        return pillarPalette[format.theme].main;
    if (format.design === ArticleDesign.LiveBlog) {
        return pillarPalette[format.theme].dark;
    }
    if (format.theme === ArticleSpecial.SpecialReport)
        return specialReport[400];
    return border.secondary;
};
const borderRichLink = (format) => {
    if (format) {
        switch (format.theme) {
            case ArticlePillar.News:
                return news[400];
            case ArticlePillar.Culture:
                return culture[350];
            case ArticlePillar.Lifestyle:
                return lifestyle[300];
            case ArticlePillar.Sport:
                return sport[400];
            case ArticlePillar.Opinion:
                return opinion[300];
            case ArticleSpecial.Labs:
                return labs[400];
            case ArticleSpecial.SpecialReport:
                return specialReport[400];
        }
    }
    return pillarPalette[ArticlePillar.News][400];
};
const borderNavPillar = (format) => pillarPalette[format.theme].bright;
const borderArticle = (format) => {
    if (format.design === ArticleDesign.LiveBlog ||
        format.design === ArticleDesign.DeadBlog)
        return '#CDCDCD';
    if (format.theme === ArticleSpecial.Labs)
        return neutral[60];
    return border.secondary;
};
const borderLines = (format) => {
    if (format.theme === ArticleSpecial.Labs)
        return border.primary;
    return border.secondary;
};
const backgroundRichLink = (format) => {
    if (format) {
        return pillarPalette[format.theme].main;
    }
    return pillarPalette[ArticlePillar.News][400];
};
const fillRichLink = (format) => {
    if (format) {
        switch (format.theme) {
            case ArticlePillar.News:
                return news[400];
            case ArticlePillar.Culture:
                return culture[350];
            case ArticlePillar.Lifestyle:
                return lifestyle[300];
            case ArticlePillar.Sport:
                return sport[400];
            case ArticlePillar.Opinion:
                return opinion[300];
            case ArticleSpecial.Labs:
                return labs[400];
            case ArticleSpecial.SpecialReport:
                return specialReport[400];
        }
    }
    return pillarPalette[ArticlePillar.News][400];
};
const fillQuoteIcon = (format) => {
    if (format) {
        return pillarPalette[format.theme].main;
    }
    return pillarPalette[ArticlePillar.News][400];
};
const textPullQuoteAttribution = (format) => fillQuoteIcon(format);
const textSignInLink = (format) => {
    return pillarPalette[format.theme].dark;
};
const textCarouselTitle = (format) => {
    return pillarPalette[format.theme].main;
};
const textCalloutHeading = () => {
    return brand[500];
};
const textDropCap = (format) => {
    switch (format.design) {
        case ArticleDesign.Editorial:
        case ArticleDesign.Letter:
        case ArticleDesign.Comment:
            return format.theme === ArticlePillar.Opinion
                ? pillarPalette[format.theme].main
                : pillarPalette[format.theme].dark;
        default:
            return pillarPalette[format.theme].dark;
    }
};
const textBlockquote = (format) => {
    switch (format.design) {
        case ArticleDesign.LiveBlog:
        case ArticleDesign.DeadBlog:
            return BLACK;
        default:
            return neutral[46];
    }
};
const textNumberedTitle = (format) => {
    return pillarPalette[format.theme].main;
};
const textNumberedPosition = () => {
    return text.supporting;
};
const textOverlayed = () => {
    return WHITE;
};
const backgroundHeadlineTag = (format) => pillarPalette[format.theme].dark;
const backgroundCarouselDot = (format) => {
    return pillarPalette[format.theme][400];
};
const backgroundCarouselDotFocus = (format) => {
    return pillarPalette[format.theme].main;
};
const backgroundMostViewedTab = (format) => {
    return pillarPalette[format.theme].dark;
};
const textPagination = (format) => {
    return blogsGrayBackgroundPalette(format);
};
const textShareCount = () => {
    return text.supporting;
};
const textShareCountUntilDesktop = (format) => {
    if (format.design === ArticleDesign.LiveBlog)
        return WHITE;
    return text.supporting;
};
const borderPagination = () => {
    return neutral[86];
};
const hoverPagination = (format) => {
    return blogsGrayBackgroundPalette(format);
};
export const decidePalette = (format) => {
    return {
        text: {
            headline: textHeadline(format),
            seriesTitle: textSeriesTitle(format),
            sectionTitle: textSectionTitle(format),
            byline: textByline(format),
            twitterHandle: textTwitterHandle(format),
            caption: textCaption(format),
            captionLink: textCaptionLink(format),
            subMeta: textSubMeta(format),
            subMetaLabel: textSubMetaLabel(format),
            subMetaLink: textSubMetaLink(format),
            syndicationButton: textSyndicationButton(format),
            articleLink: textArticleLink(format),
            articleLinkHover: textArticleLinkHover(format),
            cardHeadline: textCardHeadline(format),
            cardByline: textCardByline(format),
            cardKicker: textCardKicker(format),
            linkKicker: textLinkKicker(format),
            cardStandfirst: textCardStandfirst(format),
            cardFooter: textCardFooter(format),
            headlineByline: textHeadlineByline(format),
            standfirst: textStandfirst(format),
            standfirstLink: textStandfirstLink(format),
            branding: textBranding(format),
            disclaimerLink: textDisclaimerLink(format),
            signInLink: textSignInLink(format),
            richLink: textRichLink(format),
            pullQuote: textPullQuote(format),
            pullQuoteAttribution: textPullQuoteAttribution(format),
            witnessIcon: textWitnessIcon(format),
            witnessAuthor: textWitnessAuthor(format),
            witnessTitle: textWitnessTitle(format),
            carouselTitle: textCarouselTitle(format),
            calloutHeading: textCalloutHeading(),
            dropCap: textDropCap(format),
            blockquote: textBlockquote(format),
            numberedTitle: textNumberedTitle(format),
            numberedPosition: textNumberedPosition(),
            overlayedCaption: textOverlayed(),
            pagination: textPagination(format),
            shareCount: textShareCount(),
            shareCountUntilDesktop: textShareCountUntilDesktop(format),
        },
        background: {
            article: backgroundArticle(format),
            seriesTitle: backgroundSeriesTitle(format),
            sectionTitle: backgroundSectionTitle(format),
            avatar: backgroundAvatar(format),
            card: backgroundCard(format),
            headline: backgroundHeadline(format),
            headlineByline: backgroundHeadlineByline(format),
            bullet: backgroundBullet(format),
            bulletStandfirst: backgroundBulletStandfirst(format),
            header: backgroundHeader(format),
            standfirst: backgroundStandfirst(format),
            richLink: backgroundRichLink(format),
            imageTitle: backgroundImageTitle(format),
            speechBubble: backgroundSpeechBubble(format),
            carouselDot: backgroundCarouselDot(format),
            carouselDotFocus: backgroundCarouselDotFocus(format),
            headlineTag: backgroundHeadlineTag(format),
            mostViewedTab: backgroundMostViewedTab(format),
            matchNav: backgroundMatchNav(),
        },
        fill: {
            commentCount: fillCommentCount(format),
            commentCountUntilDesktop: fillCommentCountUntilDesktop(format),
            shareIcon: fillShareIcon(format),
            shareCountIcon: fillShareCountIcon(),
            shareCountIconUntilDesktop: fillShareCountIconUntilDesktop(format),
            shareIconGrayBackground: fillShareIconGrayBackground(format),
            cameraCaptionIcon: fillCaptionCamera(format),
            cardIcon: fillCardIcon(format),
            richLink: fillRichLink(format),
            quoteIcon: fillQuoteIcon(format),
            blockquoteIcon: fillBlockquoteIcon(format),
        },
        border: {
            syndicationButton: borderSyndicationButton(format),
            subNav: borderSubNav(format),
            articleLink: borderArticleLink(format),
            articleLinkHover: borderArticleLinkHover(format),
            liveBlock: borderLiveBlock(format),
            standfirstLink: borderStandfirstLink(format),
            headline: borderHeadline(format),
            standfirst: borderStandfirst(format),
            richLink: borderRichLink(format),
            navPillar: borderNavPillar(format),
            article: borderArticle(format),
            lines: borderLines(format),
            matchTab: matchTab(),
            activeMatchTab: activeMatchTab(),
            pagination: borderPagination(),
        },
        topBar: {
            card: topBarCard(format),
        },
        hover: {
            headlineByline: hoverHeadlineByline(format),
            pagination: hoverPagination(format),
            standfirstLink: hoverStandfirstLink(format),
        },
    };
};
